<script setup>
import { defineProps, defineEmits, ref, watch, computed } from "vue";
import Multiselect from "vue-multiselect";

const props = defineProps({
  modelValue: Array,
  options: Array,
  label: String,
  trackBy: String,
  placeholder: String,
});

const emit = defineEmits(["update:modelValue"]);

const safeOptions = computed(() =>
  Array.isArray(props.options) ? props.options : []
);

const localValue = ref(
  Array.isArray(props.modelValue) ? [...props.modelValue] : []
);

watch(
  () => [props.modelValue, localValue.value],
  ([newModelValue, newLocalValue], [oldModelValue, oldLocalValue]) => {
    if (JSON.stringify(newModelValue) !== JSON.stringify(oldModelValue)) {
      localValue.value = Array.isArray(newModelValue) ? [...newModelValue] : [];
    } else if (
      JSON.stringify(newLocalValue) !== JSON.stringify(oldLocalValue)
    ) {
      if (JSON.stringify(newLocalValue) !== JSON.stringify(newModelValue)) {
        emit("update:modelValue", newLocalValue);
      }
    }
  },
  { deep: true }
);
</script>

<template>
  <Multiselect
    v-model="localValue"
    multiple
    :show-labels="false"
    :options="safeOptions"
    :label="props.label"
    :track-by="props.trackBy"
    :placeholder="props.placeholder"
    :class="'custom-multiselect'"
  />
</template>

<style>
@import "@/styles/multiselect.css";
</style>
